import { Form, Formik } from 'formik';
import { useState } from 'react';
import { MdEdit } from 'react-icons/md';
import { toast } from 'react-toastify';
import { useTheme } from 'styled-components';

import settingsApi from '../../../APIs/settings';
import country from '../../../assets/icons/apartment.svg';
import location from '../../../assets/icons/location.svg';
import mail from '../../../assets/icons/Mail.svg';
import escConstants from '../../../constants';
import { useRoot } from '../../../context/RootProvider';
import {
  Button,
  FormContainer,
  Input,
  Typography,
} from '../../../designComponents';
import { requestAPI } from '../../../utils';
import { ContactInformationWrapper } from './style';

type ContactInfoType = {
  address1: string;
  address2: string;
  city: string;
  country: string;
  postalCode: string;
};

const ContactInformation = () => {
  const theme = useTheme();
  const { auth: user, updateAuth } = useRoot();
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialValues, _setInitialValues] = useState({
    address1: user?.contactInfo?.address1 || '',
    address2: user?.contactInfo?.address2 || '',
    city: user?.contactInfo?.city || '',
    country: user?.contactInfo?.country || '',
    postalCode: user?.contactInfo?.postalCode || '',
  });

  const handleUpdateContactInformation = async (values: ContactInfoType) => {
    try {
      setLoading(true);
      const updatedData = await requestAPI(
        settingsApi.updateContactInfo({
          contactInfo: {
            address1: values.address1 || '',
            address2: values.address2 || '',
            city: values.city || '',
            country: values.country || '',
            postalCode: values.postalCode || '',
            phoneNumber: user?.contactInfo?.phoneNumber,
          },
        }),
      );
      toast(escConstants.toastMessages.updateContactInformation);
      setLoading(false);
      if (updatedData?._id) {
        updateAuth({ ...updatedData });
      }
      setEditMode(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleEdit = () => {
    setEditMode((prev) => !prev);
  };
  return (
    // <ContactInformationContainer>
    <ContactInformationWrapper>
      <div className="heading">
        <Typography
          size={14}
          strong
          style={{ marginBottom: '10px' }}
          className="setting-title"
        >
          Contact Information
        </Typography>
        {!editMode && (
          <MdEdit
            className="btn-edit"
            onClick={handleEdit}
            style={{ cursor: 'pointer' }}
          />
        )}
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={handleUpdateContactInformation}
        enableReinitialize
      >
        {({ values, setFieldValue, handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <FormContainer label="Address Line 1" marginBottom="20px">
                <Input
                  name="address1"
                  value={values.address1}
                  onChange={(e) => setFieldValue('address1', e.target.value)}
                  iconLeft={<img src={location} alt="locaion icon" />}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                  disabled={!editMode}
                />
              </FormContainer>
              <FormContainer label="Address Line 2" marginBottom="20px">
                <Input
                  name="address2"
                  value={values.address2}
                  onChange={(e) => setFieldValue('address2', e.target.value)}
                  iconLeft={<img src={mail} alt="mail icon" />}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                  disabled={!editMode}
                />
              </FormContainer>
              <FormContainer label="City" marginBottom="20px">
                <Input
                  name="city"
                  value={values.city}
                  onChange={(e) => setFieldValue('city', e.target.value)}
                  iconLeft={<img src={country} alt="country icon" />}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                  disabled={!editMode}
                />
              </FormContainer>

              <FormContainer label="Country" marginBottom="20px">
                <Input
                  name="country"
                  value={values.country || ''}
                  onChange={(e) => setFieldValue('country', e.target.value)}
                  iconLeft={<img src={country} alt="country icon" />}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                  disabled={!editMode}
                />
              </FormContainer>

              <FormContainer label="Eircode / Post Code" marginBottom="20px">
                <Input
                  name="postCode"
                  value={values.postalCode || ''}
                  onChange={(e) => setFieldValue('postalCode', e.target.value)}
                  iconLeft={<img src={mail} alt="mail icon" />}
                  containerStyle={{
                    borderColor: !editMode
                      ? theme.colors.disable
                      : theme.colors.border,
                  }}
                  disabled={!editMode}
                />
              </FormContainer>
              <div className="btn-update">
                {editMode && (
                  <>
                    <Button
                      isLoading={loading}
                      variant="gray"
                      style={{ marginRight: '18px' }}
                      onClick={handleEdit}
                    >
                      Cancel
                    </Button>
                    <Button type="submit" isLoading={loading}>
                      Update
                    </Button>
                  </>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </ContactInformationWrapper>
    // </ContactInformationContainer>
  );
};

export default ContactInformation;
